module.exports = __webpack_public_path__ + "img/12Ox24O.d41d8cd9.svg";